export default function PageNieuwePatiënten() {
  return (
    <div>
      <h2 className="text-xl font-bold">Nieuwe patiënten</h2>
      <p>Wenst u patiënt te worden in onze praktijk? <br/>
        Indien u binnen onderstaand gebied op de kaart woont, dan kan u telefonisch contact opnemen met onze secretaresse om een intakegesprek te plannen.<br/>
      </p>
      <iframe 
          width="100%"
          height="600"
          style={{ border: 0 }}
          src="https://www.google.com/maps/d/embed?mid=1wA7f5JYqYTNm4DU5HpMIkqGvjYeILXU&ehbc=2E312F"
          allowFullScreen
          loading="lazy">
        </iframe>
    </div>
  );
}